<script>
    import { createEventDispatcher } from 'svelte'
    import OperatorItem from './OperatorItem.svelte'

    export let value = 'Placeholder'
    export let name = 'field'
    export let id = 'field'
    export let valid = true
    export let placeholder = 'Placeholder'

    const dispatch = createEventDispatcher ();

    const listFieldClick = (event) => {
        dispatch ('list', {
            name,
            id
        })
    }
</script>

<style>
    .ListField {
        background-color: #dbe4ea;
        border-radius: 2px;
        margin-bottom: 10px;
        padding: 5px 10px;
        min-height: 31px;
        /* color: #586d7d; */
        cursor: default;
    }

    .ListField.error {
        background-color: #ff7574;
        color: #fff;
    }
</style>

<div class="ListField" class:error={valid === false} on:click={listFieldClick}>
    {#if value instanceof Array && value.length > 0}
        {#each value as op (op.token_id)}
            <OperatorItem id={op.token_id} text={op.name} removable on:remove />
        {:else}
            {placeholder}
        {/each}
    {:else}
        {value}
    {/if}
</div>